// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import App from './App'
import router from './router'
import axios from 'axios'
import store from '@/store'

Vue.config.productionTip = false
Vue.use(VueMaterial)

axios.interceptors.request.use(function (config) {
  const API_DOMAIN = ['localhost', 'api-staging.neo-psy.com', 'api.neo-psy.com']
  for (var i in API_DOMAIN) {
    if (config.url.includes(API_DOMAIN[i])) {
      const USER = store.state.auth.user
      if (store.state.auth && USER && USER.token) {
        config.headers['Authorization'] = `Bearer ${USER.token}`
      }
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (!error.config) {
    Promise.reject(error)
  }
  let method = error.config.method
  let code = error.response.status
  if ([500, 404, 401, 403].includes(code)) {
    switch (code) {
      case 500:
        store.commit('snackbar/SERVER_ERROR')
        break
      case 404:
        store.commit('snackbar/NOT_FOUND')
        break
      case 401: case 403:
        store.commit('snackbar/NOT_AUTHORIZED')
        break
    }
  } else {
    switch (method) {
      case 'post':
        store.commit('snackbar/CREATE_FAILED')
        break
      case 'delete':
        store.commit('snackbar/DELETE_FAILED')
        break
      case 'put':
        store.commit('snackbar/UPDATE_FAILED')
        break
    }
  }
  return Promise.reject(error)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js